import { render, staticRenderFns } from "./FormsManagement.vue?vue&type=template&id=36f31974&scoped=true"
import script from "./FormsManagement.vue?vue&type=script&lang=js"
export * from "./FormsManagement.vue?vue&type=script&lang=js"
import style0 from "./FormsManagement.vue?vue&type=style&index=0&id=36f31974&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f31974",
  null
  
)

export default component.exports